import { render, staticRenderFns } from "./detailCount.vue?vue&type=template&id=1c28ea05"
import script from "./detailCount.vue?vue&type=script&lang=js"
export * from "./detailCount.vue?vue&type=script&lang=js"
import style0 from "./detailCount.vue?vue&type=style&index=0&id=1c28ea05&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports